import { render, staticRenderFns } from "./process-reports-chart.vue?vue&type=template&id=7653c740&scoped=true&"
import script from "./process-reports-chart.vue?vue&type=script&lang=ts&"
export * from "./process-reports-chart.vue?vue&type=script&lang=ts&"
import style0 from "./process-reports-chart.vue?vue&type=style&index=0&id=7653c740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7653c740",
  null
  
)

export default component.exports